export const baseUrl = 'https://api.themoviedb.org/3';
export const API_KEY = '70b0f6dd60e7d6eba7f271024d0eb5c5';
export const imageUrl = 'https://image.tmdb.org/t/p/original'